export const getImageField = (field: string) => [
  `${field}.filename_disk`,
  `${field}.title, ${field}.width, ${field}.height`,
];
